export const infoText = 'Add <span><b>antonyms</b>, or opposite words, by dragging them into the water</span>';